import { SxProps, Theme } from "@mui/material";

export const containerBorderSx: SxProps<Theme> = {
  border: "1px solid #dee2e6",
  borderRadius: 1,
  overflow: "hidden",
};

export const leftColDividerSx: SxProps<Theme> = {
  flex: 1,
  borderRight: { sm: "1px solid #e9ecef" },
};

export const tradeTypeChipSx: SxProps<Theme> = {
  border: "1px solid #bbdefb",
  bgcolor: "#e3f2fd",
  color: "#1976d2",
  fontWeight: 700,
  fontSize: 12,
};

export const grayChipSx: SxProps<Theme> = {
  border: "1px solid #dee2e6",
  bgcolor: "#e9ecef",
  color: "#495057",
  fontWeight: 700,
  fontSize: 12,
};

export const actionCallChipSx: SxProps<Theme> = {
  border: "1px solid #bbdefb",
  bgcolor: "#e3f2fd",
  color: "#1976d2",
  fontWeight: 700,
  fontSize: 12,
};

export const actionPutChipSx: SxProps<Theme> = {
  border: "1px solid #ffcc02",
  bgcolor: "#fff3e0",
  color: "#f57c00",
  fontWeight: 700,
  fontSize: 12,
};

export const greenMoneyChipSx: SxProps<Theme> = {
  border: "1px solid #c3e6cb",
  bgcolor: "#d4edda",
  color: "#28a745",
  fontWeight: 700,
  fontSize: 12,
};

export const legRowSx: SxProps<Theme> = {
  px: 1.25,
  py: 1,
  border: "1px solid #dee2e6",
  borderRadius: 1,
  background: "#ffffff",
};

export const payloadContainerSx: SxProps<Theme> = {
  mt: 1.5,
  p: 1.5,
  bgcolor: "#f8f9fa",
  borderRadius: 1,
  border: "1px solid #e9ecef",
};
